module.exports = __webpack_public_path__ + "6aa5938b304376d402843d9572293931.pdf";